import React, { useEffect, useState } from 'react'
import AddIcon from '@mui/icons-material/Add';
import { Badge, Box, Button, Grid, Table, TableBody, TableContainer, TableHead, Typography, useTheme } from '@mui/material'
import useSnackBar from '../../../Redux/hooks/useSnackBar';
import usePageLoader from '../../../Redux/hooks/usePageLoader';
import { useDispatch } from 'react-redux';
import { useCommonStyles } from '../../../utils';
import StyledTableRow from '../../../Component/Common/StyledTableRow';
import StyledTableCell from '../../../Component/Common/StyledTableCell';
import ErrorHandler from '../../../lib/errorHandler';
import FilterListIcon from '@mui/icons-material/FilterList';
import StatusButton from '../../../Component/Common/StatusButton';
import IconBackground from '../../../Component/Common/IconBackground';
import CommonPagination from '../../../Component/Common/CommonPagination';
import { addInventoryField, deleteInventoryField, getInventoryFieldById, getInventoryFields, updateInventoryField } from '../../../Redux/Actions/Inventory';
import { InventoryTypeInum } from '../../../lib/enum';
import CommonModal from '../../../Component/Common/CommonModal';
import CommonTextField from '../../../Component/Common/CommonTextField';
import ErrorMessage from '../../../Component/Common/ErrorMessage';
import { standardDateFormat } from '../../../lib/standardDateFormat';
import NoDataFound from '../../../Component/Common/NoDataFound';
import { useConfirm } from 'material-ui-confirm';
import { useAppSelector } from '../../../Redux/app/hooks';
import CommonInventoryFilterDrawer from '../CommonInventoryFilterDrawer';
import CommonAutoComplete from '../../../Component/Common/CommonAutoComplete';

const Size = () => {
  // =============== Hooks ===============
  const theme = useTheme();
  const { classes } = useCommonStyles();
  const dispatch = useDispatch();
  const setFullPageLoader = usePageLoader();
  const { setSnackBar } = useSnackBar();
  const confirmDialogue = useConfirm();

  // =============== States ===============
  const [page, setPage] = useState(1);
  const [size, setSize] = useState("");
  const [sizeUnit, setSizeUnit] = useState("");
  const [selectedItem, setSelectedItem] = useState({});
  const [errors, setErrors] = useState({});
  const [listData, setListData] = useState({});
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [isOpenFilterDrawer, setIsOpenFilterDrawer] = useState(false);
  const initialFilterState = {
    status: "",
  };
  const [filterData, setFilterData] = useState(initialFilterState);
  const [isApllyFilter, setIsApplyFilter] = useState(1);
  const filterDataCount = (filterData?.status?.trim() ? 1 : 0)

  const [unitPage, setUnitPage] = useState(1);
  const [unitTotalCount, setUnitTotalCount] = useState();
  const [unitList, setUnitList] = useState([]);
  const [unitOptions, setUnitOptions] = useState([]);
  const [searchUnit, setSearchUnit] = useState();

  // =============== Handler ===============
  let PerPage = 10
  const tabelHeader = ["SR.", "Size", "Size unit", "Created date", "Status", "Action"]

  const getPermissionList = useAppSelector((state) => state?.auth?.getRolePermission);
  const handleChangePage = (e, p) => {
    setPage(p);
  };

  //--------------------- Validation ------------------------------
  const validStep = () => {
    let error = {};
    let formIsValid = true;
    if (!size) {
      formIsValid = false;
      error[`size`] = `* Please enter size.`;
    }
    if (!sizeUnit?.unit) {
      formIsValid = false;
      error[`sizeUnit`] = `* Please select size unit.`;
    }
    setErrors(error);
    return formIsValid;
  };

  // ============= get Inventories API =============
  const _getInventoryFields = async (p) => {
    setFullPageLoader(true);
    let response;
    let body = {
      "inventoryFieldType": InventoryTypeInum["Size"],
      "limit": PerPage,
      "page": page,
      "status": isApllyFilter ? (filterData?.status?.trim() ? +filterData?.status : null) : null
    }
    response = await dispatch(getInventoryFields(body));
    let error = await ErrorHandler(response, setSnackBar);
    if (error) {
      if (response?.payload?.data) {
        setListData(response?.payload?.data)
      }
      setFullPageLoader(false);
    }
    setFullPageLoader(false);
  };

  // ============= add Inventory Field API =============
  const _addUpdateInventoryField = async () => {
    if (validStep()) {
      setFullPageLoader(true);
      let response;
      let body = {
        "inventoryFieldType": InventoryTypeInum["Size"],
        "size": +size,
        "sizeUnit": sizeUnit?.unit,
      }
      if (selectedItem?._id) {
        body._id = selectedItem?._id
      }
      const fn = selectedItem?._id ? updateInventoryField : addInventoryField
      response = await dispatch(fn(body));
      let error = await ErrorHandler(response, setSnackBar);
      if (error) {
        if (response?.payload?.data) {
          setSnackBar("success", response?.payload?.message)
          _getInventoryFields();
          setSelectedItem({})
          setIsOpenModal(false)
          setSize("")
          setSizeUnit("")
        }
        setFullPageLoader(false);
      }
      setFullPageLoader(false);
    }
  };

  // ============= Get By Id Inventory Field API =============
  const _getInventoryFieldById = async (id) => {
    setFullPageLoader(true);
    let response;
    let body = `/${id}`
    response = await dispatch(getInventoryFieldById(body));
    let error = await ErrorHandler(response, setSnackBar);
    if (error) {
      if (response?.payload?.data?.response) {
        setSelectedItem(response?.payload?.data?.response)
        setIsOpenModal(true)
        setSize(response?.payload?.data?.response?.size)
        setSizeUnit({ unit: response?.payload?.data?.response?.sizeUnit })
      }
      setFullPageLoader(false);
    }
    setFullPageLoader(false);
  };

  // ============= Delete Inventory Field API =============
  const _deleteInventoryField = async (id) => {
    setFullPageLoader(true);
    let response;
    let body = `/${id}`
    response = await dispatch(deleteInventoryField(body));
    let error = await ErrorHandler(response, setSnackBar);
    if (error) {
      if (response?.payload?.data?.response) {
        setSnackBar("success", response?.payload?.message)
        _getInventoryFields();
      }
      setFullPageLoader(false);
    }
    setFullPageLoader(false);
  };


  //------------------  Unit API ------------------
  const _getUnit = async (p, searchText) => {
    let response;
    let body = {
      "inventoryFieldType": InventoryTypeInum["Unit"],
      "limit": 10,
      "page": p ? p : unitPage
    };
    response = await dispatch(getInventoryFields(body));
    { (unitList?.length !== unitTotalCount) && setUnitPage(unitPage + 1) }
    let error = await ErrorHandler(response, setSnackBar);
    if (error) {
      setSearchUnit(searchText ? searchText : "");
      setUnitTotalCount(response?.payload?.data?.count);
      if (response?.payload?.data) {
        setUnitList([...unitList, ...response?.payload?.data?.response]);
      }
    }
  };
  const handleChangeInputForUnit = async (p, searchText) => {
    let response;
    let body = {
      "inventoryFieldType": InventoryTypeInum["Unit"],
      "limit": 10,
      "page": p
    };
    response = await dispatch(getInventoryFields(body));
    setUnitPage(2);
    let error = await ErrorHandler(response, setSnackBar);
    if (error) {
      setSearchUnit(searchText);
      setUnitList(response?.payload?.data?.response);
    }
  };


  // =============== Use Effects ===============
  useEffect(() => {
    _getInventoryFields();
  }, [page])
  useEffect(() => {
    _getUnit();
  }, [])

  useEffect(() => {
    setUnitOptions(unitList?.map((e) => e));
  }, [unitList]);

  useEffect(() => {
    setPage(1)
    _getInventoryFields(1);
  }, [isApllyFilter])



  return (
    <Grid container spacing={2} padding={"25px"}>
      <Grid item xs={12} display={"flex"} justifyContent={"space-between"} alignItems={"center"} flexWrap={'wrap'}>
        <Typography fontFamily={"Satoshi-Bold"} fontSize={"28px"}>Size List</Typography>
        <Box display={"flex"} gap={1} flexWrap={'wrap'}>
          <Badge badgeContent={filterDataCount || 0} sx={{ "& .MuiBadge-badge": { right: "4px", top: "10px", zIndex: 999, color: "#FFF" } }} color="primary">
            <Button className={classes.cancelButton} startIcon={<FilterListIcon />} onClick={() => setIsOpenFilterDrawer(true)}>Filters </Button>
          </Badge>
          {getPermissionList?.editPermission?.includes('Inventory Management') &&
            <Button className={classes.saveButton} startIcon={<AddIcon />} onClick={() => setIsOpenModal(true)}>Add Size</Button>
          }
        </Box>
      </Grid>
      <Grid item xs={12}>
        <Box sx={{ borderRadius: "26px", border: "1px solid", backgroundColor: theme.palette.bgWhite.main, borderColor: "#c8d3d96e", borderTop: "none" }}>
          <TableContainer>
            <Table sx={{ borderBottom: '1px solid #c8d3d96e' }}>
              <TableHead>
                <StyledTableRow isHeader style={{ backgroundColor: "#E9E9E9" }}>
                  {tabelHeader?.map((ele) => {
                    return (
                      <StyledTableCell>{ele}</StyledTableCell>
                    )
                  })}
                </StyledTableRow>
              </TableHead>
              <TableBody>
                {listData?.response?.length > 0 ?
                  listData?.response?.map((row, index) => (
                    <React.Fragment key={index}>
                      <StyledTableRow>
                        <StyledTableCell> {index + 1 + (page - 1) * PerPage}</StyledTableCell>
                        <StyledTableCell> {row.size ? row.size : "NA"}</StyledTableCell>
                        <StyledTableCell> {row.sizeUnit ? row.sizeUnit : "NA"}</StyledTableCell>
                        <StyledTableCell> {row?.createdAt && standardDateFormat(row?.createdAt)}</StyledTableCell>
                        <StyledTableCell>
                          <StatusButton text={row.status == 2 ? "Not In Use" : "In Use"} color={row.status == 2 ? "gray" : "success"} />
                        </StyledTableCell>
                        <StyledTableCell>
                          <Box display={"flex"} gap={1}>
                            {getPermissionList?.editPermission?.includes('Inventory Management') &&
                              <IconBackground icon={"edit"} disabled={row.status === 1} onClick={() => _getInventoryFieldById(row?._id)} />
                            }
                            {getPermissionList?.editPermission?.includes('Inventory Management') &&
                              <IconBackground icon={"delete"} disabled={row.status === 1}
                                onClick={(e) => {
                                  confirmDialogue({
                                    title: `Are you sure you want to delete?`,
                                  }).then(() => {
                                    _deleteInventoryField(row?._id)
                                  }).catch((err) => { console.error(err) });
                                }}
                              />
                            }
                          </Box>
                        </StyledTableCell>
                      </StyledTableRow>
                    </React.Fragment>
                  ))
                  :
                  <StyledTableRow>
                    <StyledTableCell colSpan={12}>
                      <NoDataFound />
                    </StyledTableCell>
                  </StyledTableRow>
                }
              </TableBody>
            </Table>
          </TableContainer>
          <CommonPagination
            totalCount={listData?.count}
            count={Math.ceil(listData?.count / PerPage)}
            itemsPerPage={PerPage}
            page={page}
            onChange={handleChangePage}
          />
        </Box>
      </Grid>
      <CommonInventoryFilterDrawer isOpenFilterDrawer={isOpenFilterDrawer} setIsOpenFilterDrawer={setIsOpenFilterDrawer} setFilterData={setFilterData} initialFilterState={initialFilterState} filterData={filterData} setIsApplyFilter={setIsApplyFilter} isApllyFilter={isApllyFilter} />
      <CommonModal
        open={isOpenModal}
        onClose={() => { setIsOpenModal(false); setSelectedItem({}); setErrors({}); setSize(""); setSizeUnit(""); }}
        title={`${selectedItem?._id ? "Edit" : "Add"} Size`}
        submitButtonName={selectedItem?._id ? "Update" : "Add"}
        onHandleCancel={() => { setErrors({}); setSize(""); setSizeUnit(""); setIsOpenModal(false) }}
        onHandleSubmit={() => _addUpdateInventoryField()}
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <CommonTextField
              valid
              type="number"
              label="Size"
              name="size"
              value={size}
              placeholder="Enter The Size"
              onChange={(e) => {
                if (+e?.target?.value >= 0) {
                  setSize(e.target.value)
                } else {
                  return;
                }
              }}
            />
            <ErrorMessage text={!size ? errors?.size : ""} />
          </Grid>
          <Grid item xs={12}>
            <CommonAutoComplete
              label="Size Unit"
              valid
              placeholder="Select Unit"
              clearIcon={false}
              options={unitOptions || []}
              getOptionLabel={(option) => option?.unit || ""}
              value={sizeUnit || null}
              onChange={(e, newValue) => setSizeUnit(newValue)}
              loadData={(unitOptions?.length !== unitTotalCount) ? _getUnit : undefined}
              handleSearch={(e) => handleChangeInputForUnit(1, e?.target?.value)}
              searchValue={searchUnit}
            />
            <ErrorMessage text={!sizeUnit?.unit ? errors?.sizeUnit : ""} />
          </Grid>
        </Grid>
      </CommonModal>
    </Grid>
  )
}

export default Size